var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPin = function SvgPin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 8.43C4 5.15 6.69 2.5 10 2.5s6 2.66 6 5.93c0 1.31 0 2.07-1 3.57s-3.28 4.39-4.44 5.27l-.03.02c-.17.14-.26.21-.54.21-.261 0-.357-.07-.515-.185a6.572 6.572 0 0 0-.035-.025l-.02-.02C8.26 16.4 6 13.5 5 12c-1-1.5-1-2.26-1-3.57Zm8.22 5.94c.83-1.01 1.63-2.09 2.11-2.81h.01c.46-.69.66-1.17.76-1.59.1-.44.1-.87.1-1.54 0-2.83-2.32-5.13-5.2-5.13-2.88 0-5.2 2.3-5.21 5.15 0 .67 0 1.09.1 1.53.1.42.3.89.76 1.59.48.73 1.28 1.8 2.1 2.81.84 1.02 1.64 1.9 2.13 2.27l.03.02.04.04h.03l.02-.02.04-.03.03-.02c.5-.37 1.31-1.24 2.15-2.27ZM7 8c0-1.66 1.34-3 3-3s3 1.34 3 3-1.34 3-3 3-3-1.34-3-3Zm.8 0c0 1.22.98 2.2 2.2 2.2 1.22 0 2.2-.98 2.2-2.2 0-1.22-.98-2.2-2.2-2.2-1.22 0-2.2.98-2.2 2.2Z",
    fill: "#282830"
  })));
};
export default SvgPin;